// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-summary-bar[data-v-0f0e7db7]{align-items:center;background:#fff;border-top:1px solid #dedede;cursor:pointer;display:flex;flex-direction:row;height:13vw;justify-content:flex-start;width:100vw}@media screen and (min-width:320px) and (max-width:998px) and (orientation:landscape){.search-summary-bar[data-v-0f0e7db7]{height:2.5em}}.search-summary-bar.desktop[data-v-0f0e7db7]{background:#e4e8ec;border:none;height:auto;padding:.5em 1em;width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
